"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = exports.Header = exports.Base = void 0;
var React = require("react");
var DOM = require("react-dom-factories");
var hnf = require("@wix/marketing-header-and-footer");
var s = require("./HeaderAndFooter.scss");
var Base = /** @class */ (function (_super) {
    __extends(Base, _super);
    function Base(props) {
        var _this = _super.call(this, props) || this;
        // instance
        _this.ready = false;
        if (Base.instances[_this.component]) {
            console.warn("Hey, you're creating second instance of <" + _this.displayName + ">, why? When initializing component, previous will be ignored.");
        }
        Base.instances[_this.component] = _this;
        if (props.config) {
            if (Base.config) {
                Base.warnAboutSharedProp('config', _this);
            }
            Base.config = Object.assign({}, props.config);
        }
        if (props.ssr) {
            if (Base.renderer) {
                Base.warnAboutSharedProp('ssr', _this);
            }
            var _a = props.ssr, translations = _a.translations, user = _a.user, location_1 = _a.location;
            Base.renderer = hnf.serverSideRenderer(Base.hnfConfig, translations, user, location_1);
        }
        return _this;
    }
    Base.loadCSSBundle = function () {
        if (typeof window === 'undefined') {
            return;
        }
        if (Base.css) {
            return;
        }
        Base.css = document.createElement('link');
        Object.assign(Base.css, {
            href: (Base.hnfConfig.baseUrl || hnf.baseUrl()) + "/app.min.css",
            rel: 'stylesheet',
            type: 'text/css',
            onload: function () {
                Base.cssReady = true;
                Base.embedIfReady();
            }
        });
        var append = function () { return document.body.appendChild(Base.css); };
        document.body ? append() : document.addEventListener('DOMContentLoaded', append, false);
        return;
    };
    Base.loadNewWixHeader2020 = function () {
        if (typeof window === 'undefined') {
            return;
        }
        if (Base.cssNewHeader2020) {
            return;
        }
        Base.cssNewHeader2020 = document.createElement('link');
        Object.assign(Base.cssNewHeader2020, {
            href: '//static.parastorage.com/unpkg-semver/header-footer-wix-statics/app.min.css',
            rel: 'stylesheet',
            type: 'text/css',
            onload: function () {
                Base.cssNewHeader2020Ready = true;
                Base.embedIfReady();
            }
        });
        Base.jsNewHeader2020 = document.createElement('script');
        Object.assign(Base.jsNewHeader2020, {
            src: '//static.parastorage.com/unpkg-semver/header-footer-wix-statics/app.bundle.min.js',
            onload: function () {
                Base.jsNewHeader2020Ready = true;
                Base.embedIfReady();
            }
        });
        Base.wixFontMadeFor = document.createElement('link');
        Object.assign(Base.wixFontMadeFor, {
            href: "//static.parastorage.com/unpkg/@wix/wix-fonts@1.9.3/madefor.min.css",
            rel: 'stylesheet',
            type: 'text/css',
            onload: function () {
                Base.wixFontMadeForReady = true;
                Base.embedIfReady();
            }
        });
        Base.wixFontMadeForDisplay = document.createElement('link');
        Object.assign(Base.wixFontMadeForDisplay, {
            href: "//static.parastorage.com/unpkg/@wix/wix-fonts@1.9.3/madeforDisplay.min.css",
            rel: 'stylesheet',
            type: 'text/css',
            onload: function () {
                Base.wixFontMadeForDisplayReady = true;
                Base.embedIfReady();
            }
        });
        var append = function () {
            document.body.appendChild(Base.cssNewHeader2020);
            document.body.appendChild(Base.jsNewHeader2020);
            document.body.appendChild(Base.wixFontMadeFor);
            document.body.appendChild(Base.wixFontMadeForDisplay);
        };
        document.body ? append() : document.addEventListener('DOMContentLoaded', append, false);
        return;
    };
    Base.warnAboutSharedProp = function (prop, instance) {
        console.warn("Prop '" + prop + "' was rewritten by <" + instance.displayName + "> and shared between <Header> and <Footer> instances.");
    };
    Object.defineProperty(Base, "instancesNames", {
        get: function () {
            return Object.keys(Base.instances);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Base, "instancesReady", {
        get: function () {
            return Base.instancesNames
                .map(function (instanceName) { return Base.instances[instanceName].ready; })
                .indexOf(false) < 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Base, "rootNodes", {
        get: function () {
            return Base.instancesNames
                .reduce(function (accumulator, instanceName) {
                accumulator[instanceName] = Base.instances[instanceName].refs['root'];
                return accumulator;
            }, {});
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Base, "hnfConfig", {
        get: function () {
            return Base.config || {};
        },
        enumerable: false,
        configurable: true
    });
    Base.embedIfReady = function () {
        if (!Base.cssReady ||
            !Base.instancesNames.length ||
            !Base.instancesReady ||
            !Base.cssNewHeader2020Ready ||
            !Base.jsNewHeader2020Ready ||
            !Base.wixFontMadeForReady ||
            !Base.wixFontMadeForDisplayReady) {
            return;
        }
        var config = Object.assign({}, Base.hnfConfig);
        if (Base.instancesNames.length === 1) {
            Object.assign(config, { useOnly: Base.instancesNames[0] });
        }
        hnf.embed(config, this.rootNodes, true);
    };
    Object.defineProperty(Base.prototype, "displayName", {
        get: function () {
            return this.constructor.displayName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Base.prototype, "component", {
        get: function () {
            return this.displayName.toLowerCase();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Base.prototype, "renderer", {
        get: function () {
            return Base.renderer ? Base.renderer[this.component] : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Base.prototype, "rootTag", {
        get: function () {
            var tag = this.props.tag;
            return tag in DOM ? tag : this.component;
        },
        enumerable: false,
        configurable: true
    });
    Base.prototype.componentWillMount = function () {
        Base.loadCSSBundle();
        Base.loadNewWixHeader2020();
    };
    Base.prototype.componentDidMount = function () {
        this.ready = true;
        Base.embedIfReady();
    };
    Base.prototype.componentWillUnmount = function () {
        this.ready = false;
        delete Base.config;
        delete Base.instances[this.component];
    };
    Base.prototype.shouldComponentUpdate = function () {
        return false;
    };
    Base.prototype.render = function () {
        var withHeaderStartHeight = this.props.withHeaderStartHeight;
        var attrs = {
            ref: 'root',
            style: {
                visibility: 'hidden',
            },
            className: withHeaderStartHeight && this.component === 'header' ? s.wrapper : ''
        };
        if (this.renderer) {
            Object.assign(attrs, { dangerouslySetInnerHTML: { __html: this.renderer.innerHTML() } });
        }
        return DOM[this.rootTag](attrs);
    };
    Base.css = null;
    Base.cssReady = false;
    Base.cssNewHeader2020 = null;
    Base.cssNewHeader2020Ready = false;
    Base.jsNewHeader2020 = null;
    Base.jsNewHeader2020Ready = false;
    Base.wixFontMadeFor = null;
    Base.wixFontMadeForReady = false;
    Base.wixFontMadeForDisplay = null;
    Base.wixFontMadeForDisplayReady = false;
    Base.config = null;
    Base.instances = {};
    return Base;
}(React.Component));
exports.Base = Base;
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Header.displayName = 'Header';
    return Header;
}(Base));
exports.Header = Header;
var Footer = /** @class */ (function (_super) {
    __extends(Footer, _super);
    function Footer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Footer.displayName = 'Footer';
    return Footer;
}(Base));
exports.Footer = Footer;
//# sourceMappingURL=HeaderAndFooter.js.map